import { Injectable } from '@angular/core';
import { HttpService, VersionedData } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { PaymentDto } from '../dtos';

@Injectable()
export class PaymentsService {
  private path = 'versionedupdate/payments';
  constructor(private httpService: HttpService) {}

  public getPayments(versionHash: string): Observable<VersionedData<PaymentDto[]>> {
    return this.httpService.makeGet(`${this.path}/${versionHash}`);
  }
}
